'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.makeHTMLDriver = makeHTMLDriver;

var _most = require('most');

var _snabbdomToHtml = require('snabbdom-to-html');

var _snabbdomToHtml2 = _interopRequireDefault(_snabbdomToHtml);

var _transposition = require('./transposition');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTMLSource = function () {
  function HTMLSource(vNode$) {
    _classCallCheck(this, HTMLSource);

    this._html$ = (0, _most.fromPromise)(vNode$.reduce(function (_, x) {
      return x;
    }, void 0)).map(_snabbdomToHtml2.default);
  }

  _createClass(HTMLSource, [{
    key: 'select',
    value: function select() {
      return new HTMLSource((0, _most.empty)());
    }
  }, {
    key: 'events',
    value: function events() {
      return (0, _most.empty)();
    }
  }, {
    key: 'elements',
    get: function get() {
      return this._html$;
    }
  }]);

  return HTMLSource;
}();

function makeHTMLDriver() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var transposition = options.transposition || false;
  return function htmlDriver(vNode$) {
    var preprocessedVNode$ = transposition ? vNode$.map(_transposition.transposeVNode).switch() : vNode$;
    return new HTMLSource(preprocessedVNode$);
  };
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/makeHTMLDriver.js
 **/